<template>
  <div class="oap-rating">
    <div class="oap-rating__list">
      <div class="oap-rating__stars">
        <span class="oap-rating__star--empty"></span>
        <span class="oap-rating__star--fill" :style="`width: ${ratingPercentage};`"></span>
      </div>
      <span
        class="oap-rating__average"
        :class="{ '-mobile-visible': displayReviewCount }"
        :style="`color: {{textColor}};`"
      >
        {{ rating }}/{{ ratingMax }}<span v-if="ratingCountText">&nbsp;{{ ratingCountText }}</span>
      </span>
      <span class="is-sr-only">
        {{ srText }}
      </span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  rating: {
    type: Number,
    default: 0,
  },

  ratingMax: {
    type: Number,
    default: 5,
  },

  ratingPercentage: {
    type: String,
    default: '0%',
  },

  textColor: {
    type: [String, null],
    default: null,
  },

  srText: {
    type: String,
    default: '',
  },

  displayReviewCount: {
    type: Boolean,
    default: false,
  },

  ratingCountText: {
    type: String,
    default: '',
  },
});
</script>
